import { useTranslation } from 'react-i18next'
import type { IngestionRun } from '../../../types/ingestion'
import {
  EmptyState,
  ErrorState,
  LoadingState,
  RunRow,
  TableHeader,
} from './ingestion-runs-section/ingestion-runs-section.parts'

interface IngestionRunsSectionProps {
  runs: IngestionRun[]
  loading: boolean
  error: string | null
  selectedRunId: string | null
  onSelectRun: (runId: string | null) => void
}

export function IngestionRunsSection({
  runs,
  loading,
  error,
  selectedRunId,
  onSelectRun,
}: IngestionRunsSectionProps): React.ReactElement {
  const { t } = useTranslation('cases')

  if (loading) return <LoadingState t={t} />
  if (error) return <ErrorState message={error} />
  if (runs.length === 0) return <EmptyState t={t} />

  const handleSelect = (runId: string): void => {
    onSelectRun(selectedRunId === runId ? null : runId)
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <TableHeader t={t} />
        <tbody>
          {runs.map((run) => (
            <RunRow
              key={run.id}
              run={run}
              isSelected={selectedRunId === run.id}
              onSelect={handleSelect}
              t={t}
            />
          ))}
        </tbody>
      </table>
    </div>
  )
}
